(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/dialogs/swedbank-express-dialogs.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/dialogs/swedbank-express-dialogs.js');
'use strict';

const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const {
  showDepositSuccess
} = svs.accountservicesReact.deposit.dialogs.sharedDialogs;
const {
  backendErrorCodes,
  oauthStatus
} = svs.accountservicesReact.deposit.constants.swedbankExpress;
const getErrorAuthenticationMessage = errorCode => {
  switch (errorCode) {
    case backendErrorCodes.GENERAL_ERROR:
      return {
        title: 'Tekniskt fel',
        text: 'Försök igen senare eller kontakta Svenska Spels Kundservice.'
      };
    case backendErrorCodes.CUSTOMER_HAS_MULTIPLE_BANKS:
      return {
        title: 'Du är kund i flera banker i Swedbank eller Sparbankerna',
        text: 'Var vänlig välj bank på nästa sida!</br>(detta skall troligtvis inte visas för kund)'
      };
    case backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_SUBSIDIARY:
      return {
        title: 'Konton saknas',
        text: 'Vi kan inte hitta något konto som kan användas för insättningar i denna tjänst.</br></br>Välj en annan bank, eller hör av dig till ditt bankkontor om du tycker att detta inte stämmer.',
        button: 'Okej'
      };
    case backendErrorCodes.CUSTOMER_CANCELLED:
      return {
        title: 'Verifieringen med BankID avbröts',
        text: 'Din BankID-identifiering slutfördes inte.</br></br>För att fortsätta behöver du försöka igen.',
        button: 'Okej'
      };
    case backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_GROUP:
    case backendErrorCodes.USER_CONTACT_SWEDBANK:
      return {
        title: 'Vi kan inte hitta ett konto du kan använda för insättning med denna tjänst',
        text: 'Läs mer på swedbank.se eller hos sparbankerna.',
        button: 'Okej'
      };
    case oauthStatus.oauth2sts_FINAL_FAILED_UNSPECIFIED_REASON:
      return {
        title: 'Godkännandet tog för lång tid',
        text: 'Oroa dig inte, du kan försöka igen.</br></br>För att godkänna läser du av QR-koden med Mobila BankID och följer instruktionerna i appen.',
        button: 'Okej'
      };
    case backendErrorCodes.CUSTOMER_CONTACT_BANK_KYC:
      return {
        title: 'Problem vid insättning',
        text: 'Något gick fel vid insättning med Swedbank Express.</br></br>Du behöver kontakta din bank för att åtgärda detta eller välja en annan insättningsmetod.',
        button: 'Okej'
      };
    default:
      logger.warn("Unhandled error code ".concat(errorCode));
      return {
        title: 'Fel vid identifiering med BankID',
        text: 'Försök igen senare eller kontakta Svenska Spels Kundservice.'
      };
  }
};

const showAuthenticationErrorAsync = errorCode => new Promise(resolve => {
  const {
    title,
    text,
    button
  } = getErrorAuthenticationMessage(errorCode);
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.ERROR,
    allowDimmerClick: false,
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text,
      align: svs.ui.dialog.message.align.CENTER
    }],
    actions: [{
      title: button && button.length > 0 ? button : 'Stäng',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  svs.ui.dialog.api.close();
  svs.ui.dialog.api.add(dialog);
});

const getDepositErrorMessage = errorCode => {
  switch (errorCode) {
    case backendErrorCodes.INSUFFICIENT_FUND:
      return {
        title: 'Insättningen nekades',
        text: 'Täckning saknas på valt konto'
      };
    case backendErrorCodes.DEPOSIT_ABOVE_LIMIT:
      return {
        title: 'Fel vid insättning',
        text: 'Högsta insättningsbelopp är 25 000 kr.'
      };
    case backendErrorCodes.DEPOSIT_BELOW_LIMIT:
      return {
        title: 'Fel vid insättning',
        text: 'Du har angett för lågt belopp, höj beloppet och försök igen, minsta belopp är 25 kr.'
      };
    case backendErrorCodes.DEPOSIT_BUDGET_NOT_SET:
      return {
        title: 'Fel vid insättning',
        text: 'Du har inte satt någon insättningsgräns, sätt insättningsgräns och försök igen.'
      };
    case backendErrorCodes.DEPOSIT_DAY_LIMIT_EXCEEDED:
      return {
        title: 'Fel vid insättning',
        text: 'Du har överskridit din dagliga insättningsgräns. Kontrollera dina insättningsgränser och försök igen.' + 'Har du nyligen gjort en överföring som blev misslyckad/avbruten, avvakta 30 minuter och försök igen.'
      };
    case backendErrorCodes.DEPOSIT_WEEK_LIMIT_EXCEEDED:
      return {
        title: 'Fel vid insättning',
        text: 'Du har överskridit din insättningsgräns för veckan. Kontrollera dina insättningsgränser och försök igen.' + 'Har du nyligen gjort en överföring som blev misslyckad/avbruten, avvakta 30 minuter och försök igen.'
      };
    case backendErrorCodes.DEPOSIT_MONTH_LIMIT_EXCEEDED:
      return {
        title: 'Fel vid insättning',
        text: 'Du har överskridit din insättningsgräns för månaden. Kontrollera dina insättningsgränser och försök igen.' + 'Har du nyligen gjort en överföring som blev misslyckad/avbruten, avvakta 30 minuter och försök igen.'
      };
    case backendErrorCodes.USER_CONTACT_SWEDBANK:
      return {
        title: 'Fel från Swedbank',
        text: 'Var vänlig kontakta din bank för att åtgärda problemet.'
      };
    default:
      logger.warn("Unhandled error code ".concat(errorCode));
      return {
        title: 'Fel vid insättning',
        text: 'Försök igen senare eller kontakta Svenska Spels Kundservice.'
      };
  }
};

const showDepositErrorAsync = errorCode => new Promise(resolve => {
  const {
    title,
    text,
    button
  } = getDepositErrorMessage(errorCode);
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.ERROR,
    allowDimmerClick: false,
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text,
      align: svs.ui.dialog.message.align.CENTER
    }],
    actions: [{
      title: button && button.length > 0 ? button : 'Stäng',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  svs.ui.dialog.api.close();
  svs.ui.dialog.api.add(dialog);
});

const showChangeBankQuestionAsync = () => new Promise((resolve, reject) => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'help',
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    allowDimmerClick: false,
    title: 'Vill du byta bank?',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Expressbetalning är en tjänst för Swedbank och Sparbankerna.',
      align: svs.ui.dialog.message.align.CENTER
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: 'Du kan endast byta inom dessa banker.',
      align: svs.ui.dialog.message.align.CENTER
    }],
    actions: [{
      title: 'Avbryt',
      callback: () => {
        dialog.close();
        reject();
      }
    }, {
      title: 'Byt bank',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  svs.ui.dialog.api.close();
  svs.ui.dialog.api.add(dialog);
});

const showExpressMoreInformationAsync = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'information',
    branding: svs.ui.dialog.branding.TUR,
    area: svs.ui.dialog.area.POPUP,
    allowDimmerClick: false,
    title: 'Om Expressbetalning',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'När du sätter in pengar till ditt spelkonto med Expressbetalning så ger du samtidigt ditt medgivande till en säker ' + 'uppkoppling mot dina bankkonton hos Swedbank. När en koppling är upprättad signerar du enkelt insättningen med Mobilt BankID. ' + 'Det enda som krävs är att du är kund hos Swedbank eller någon av Sparbankerna.',
      align: svs.ui.dialog.message.align.CENTER
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  svs.ui.dialog.api.close();
  svs.ui.dialog.api.add(dialog);
});
svs.accountservicesReact.deposit.dialogs.swedbankExpressDialogs = {
  showDepositSuccess,
  showDepositErrorAsync,
  showChangeBankQuestionAsync,
  showExpressMoreInformationAsync,
  showAuthenticationErrorAsync
};

 })(window);